import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Volumes/extdisk/project/web/sprunki-rule/lib/components/AdBanner.tsx");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/lib/components/breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Volumes/extdisk/project/web/sprunki-rule/lib/components/faq.tsx");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/lib/components/favorites.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Volumes/extdisk/project/web/sprunki-rule/lib/components/footer.tsx");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/lib/components/get-theme-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Volumes/extdisk/project/web/sprunki-rule/lib/components/microsoft-clarity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Volumes/extdisk/project/web/sprunki-rule/lib/components/navbar.tsx");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/lib/components/skeletons.tsx");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/lib/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/Volumes/extdisk/project/web/sprunki-rule/lib/ui/components/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["NextUIProvider"] */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/next/dist/client/script.js");
